
<ElForm v-bind="rootProps" v-on="$listeners" ref="formRef" :model="query">
    <SortComponent :disabled="!sortable">
        <slot name="prepend"></slot>
        <template v-for="(item, key) of datum">
            <component
                :is="getComponent(item.t)"
                :key="key"
                v-bind="item"
                :field="item.as || key"
                :resetToInitialValue="
                    typeof item.resetToInitialValue === undefined ? resetToInitialValue : item.resetToInitialValue
                "
                :backfill="backfill"
                :query="query"
            />
        </template>
        <slot></slot>
    </SortComponent>
    <slot name="btn" :search="search" :reset="reset" :resetAndSearch="resetAndSearch">
        <template v-if="renderBtn">
            <ElButton :size="size" @click="search">{{ searchText }}</ElButton>
            <ElButton :size="size" @click="resetTriggerSearch ? resetAndSearch() : reset()">
                {{ resetText }}
            </ElButton>
        </template>
    </slot>
</ElForm>
